import API from './fetch'
import { searchRoomURL, getRoomsInfoURL } from './url'
import { appendParams } from 'utilities/paramsFormat'

const Rooms = {
  get(data) {
    const url = appendParams(searchRoomURL(), data)
    return API.getData(url)
  },
  getSelectedData(payload) {
    const url = appendParams(getRoomsInfoURL(), payload)
    return API.getData(url)
  }
}

export default Rooms
